import React, { useState, useEffect } from "react";

// JuhiHome.jsx
// Mobile-first, dark-themed, responsive React component with dummy data.
// Drop this file into your React app (MERN front-end). Tailwind CSS recommended.

export default function JuhiHome() {
  const categories = [
    { name: "Daily Pooja", emoji: "🪔" },
    { name: "Pooja Hamper", emoji: "🎁" },
    { name: "Birthday", emoji: "🎂" },
    { name: "Anniversary", emoji: "💞" },
    { name: "Live N Romance", emoji: "🌹" },
    { name: "Thank You", emoji: "🙏" },
    { name: "Congratulations", emoji: "🎉" },
    { name: "Welcome", emoji: "🌼" },
    { name: "Gifting", emoji: "🎀" },
    { name: "Festival Bulk", emoji: "🪅" },
    { name: "Venue Decoration", emoji: "🏵️" },
    { name: "Home Bouquet", emoji: "💐" },
    { name: "Nursery", emoji: "🪴" },
    { name: "Reith", emoji: "⚱️" },
    { name: "Artificial", emoji: "🌸" },
    ];

  const dummyProducts = [
    {
      id: "p01",
      title: "Marigold Pooja Garland",
      category: "Daily Pooja",
      price: 199,
      desc: "Fresh marigold garland suitable for daily worship.",
      rating: 4.5,
    },
    {
      id: "p02",
      title: "Pooja Hamper - Silver",
      category: "Pooja Hamper",
      price: 999,
      desc: "Complete pooja hamper with diya, kumkum, incense and small bell.",
      rating: 4.7,
    },
    {
      id: "p03",
      title: "Birthday Mixed Bouquet",
      category: "Birthday",
      price: 799,
      desc: "Bright seasonal flowers in a kraft wrap for birthdays.",
      rating: 4.6,
    },
    {
      id: "p04",
      title: "Anniversary Red Roses",
      category: "Anniversary",
      price: 1299,
      desc: "Classic dozen red roses with ribbon and message card.",
      rating: 4.8,
    },
    {
      id: "p05",
      title: "Romantic Lighted Vase",
      category: "Live N Romance",
      price: 1599,
      desc: "LED-lit vase with preserved roses for a romantic evening.",
      rating: 4.4,
    },
    {
      id: "p06",
      title: "Thank You Mini Posy",
      category: "Thank You",
      price: 349,
      desc: "Small posy with seasonal filler — perfect for a thank you.",
      rating: 4.3,
    },
    {
      id: "p07",
      title: "Welcome Door Wreath",
      category: "Welcome",
      price: 499,
      desc: "Hand-tied wreath for your entrance — fresh and fragrant.",
      rating: 4.2,
    },
    {
      id: "p08",
      title: "Bulk Festival Marigold (100 pcs)",
      category: "Festival Bulk",
      price: 2499,
      desc: "Bulk marigolds for festivals and community decorations.",
      rating: 4.6,
    },
    {
      id: "p09",
      title: "Home Bouquet - Seasonal",
      category: "Home Bouquet",
      price: 599,
      desc: "Table centerpiece bouquet to brighten your living room.",
      rating: 4.5,
    },
    {
      id: "p10",
      title: "Nursery: Money Plant (Small)",
      category: "Nursery",
      price: 299,
      desc: "Easy-care money plant in biodegradable pot.",
      rating: 4.4,
    },
    {
      id: "p11",
      title: "Artificial Orchid Stem",
      category: "Artificial",
      price: 499,
      desc: "Lifelike artificial orchid — no maintenance.",
      rating: 4.1,
    },
  ];

  const [query, setQuery] = useState("");
  const [selectedCat, setSelectedCat] = useState("All");
  const [products, setProducts] = useState(dummyProducts);
  const [favorites, setFavorites] = useState(() => {
    try {
      const s = localStorage.getItem("juhi_favs");
      return s ? JSON.parse(s) : [];
    } catch (e) {
      return [];
    }
  });
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    localStorage.setItem("juhi_favs", JSON.stringify(favorites));
  }, [favorites]);

  useEffect(() => {
    // simple client-side filter
    let res = dummyProducts.filter((p) =>
      `${p.title} ${p.desc}`.toLowerCase().includes(query.toLowerCase())
    );
    if (selectedCat !== "All") res = res.filter((p) => p.category === selectedCat);
    setProducts(res);
  }, [query, selectedCat]);

  function toggleFav(id) {
    setFavorites((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  }

  function clearFilters() {
    setQuery("");
    setSelectedCat("All");
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black text-gray-100 p-4 md:p-8">
      {/* Header */}
      <header className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Juhi — Flower Portal</h1>
          <p className="text-sm text-gray-400">Flowers, hampers & decor — mobile-first experience</p>
        </div>
        <div className="flex items-center gap-2">
          <button
            className="p-2 rounded-lg bg-gray-800/60 hover:bg-gray-800/80"
            title="notifications"
          >
            {/* Bell SVG */}
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 11-6 0h6z" />
            </svg>
          </button>
        </div>
      </header>

      {/* Search + Quick actions */}
    <section className="mb-4 relative z-20">
        <div className="flex gap-2">
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search flowers, hampers, occasions..."
            className="flex-1 p-3 rounded-lg bg-gray-800/50 placeholder-gray-400 outline-none"
          />
          <button
            onClick={clearFilters}
            className="p-3 rounded-lg bg-gray-700/60 text-sm font-medium"
          >
            Clear
          </button>
        </div>

        <div className="mt-3 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2 pb-6">
            <button
            onClick={() => setSelectedCat("All")}
            className={`flex items-center justify-center gap-2 whitespace-nowrap px-3 py-2 rounded-full text-sm ${selectedCat === "All" ? "bg-pink-600" : "bg-gray-800/40"}`}
            >
            🌺 All
            </button>
            {categories.map((c) => (
            <button
                key={c.name}
                onClick={() => setSelectedCat(c.name)}
                className={`flex items-center justify-center gap-2 whitespace-nowrap px-3 py-2 rounded-full text-sm ${selectedCat === c.name ? "bg-pink-600" : "bg-gray-800/40"}`}
            >
                <span>{c.emoji}</span>
                <span>{c.name}</span>
            </button>
            ))}
        </div>
      </section>

      {/* Featured banner */}
      <section className="mb-4">
        <div className="rounded-xl p-4 bg-gradient-to-r from-pink-900/40 via-pink-800/30 to-transparent border border-gray-800">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-lg font-semibold">Festival Special: Bulk Marigolds</h2>
              <p className="text-sm text-gray-300">Perfect for weddings & community pujas — limited stock</p>
            </div>
            <div className="text-right">
              <div className="text-xl font-bold">₹2499</div>
              <div className="text-xs text-gray-400">100 pcs</div>
            </div>
          </div>
        </div>
      </section>

      {/* Product grid */}
      <section className="mb-8">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
          {products.length === 0 ? (
            <div className="col-span-2 p-6 bg-gray-800/50 rounded-lg text-center">
              <p className="font-medium">No items match your search.</p>
              <p className="text-sm text-gray-400">Try clearing filters or search different keywords.</p>
            </div>
          ) : (
            products.map((p) => (
              <article key={p.id} className="bg-gray-800/30 rounded-lg p-3 flex flex-col gap-2 border border-pink-400">
                <div className="flex items-start justify-between gap-2">
                  <div className="w-16 h-16 rounded-md bg-gradient-to-br from-pink-700 to-pink-500 flex items-center justify-center text-white font-bold">
                    {/* simple flower icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M12 3v18M3 12h18" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-sm font-semibold">{p.title}</h3>
                    <p className="text-xs text-gray-400">{p.category}</p>
                    <p className="text-xs mt-1 text-gray-300 line-clamp-2">{p.desc}</p>
                  </div>
                </div>

                <div className="flex items-center justify-between mt-2">
                  <div>
                    <div className="text-sm font-bold">₹{p.price}</div>
                    <div className="text-xs text-gray-400">⭐ {p.rating}</div>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => toggleFav(p.id)}
                      className={`p-2 rounded-md ${favorites.includes(p.id) ? "bg-pink-600 text-white" : "bg-gray-700/50 text-gray-200"}`}
                      aria-label="toggle favorite"
                    >
                      {favorites.includes(p.id) ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 18.657 3.172 11.83a4 4 0 010-5.657z" />
                        </svg>
                      ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4 4 0 015.656 0L12 8.343l2.026-2.025a4 4 0 115.656 5.656L12 21.657l-7.682-7.683a4 4 0 010-5.656z" />
                        </svg>
                      )}
                    </button>

                    <button
                      onClick={() => setSelectedProduct(p)}
                      className="px-3 py-2 rounded-md bg-pink-600 text-sm font-medium"
                    >
                      View
                    </button>
                  </div>
                </div>
              </article>
            ))
          )}
        </div>
      </section>

      {/* Bottom quick actions */}
      <nav className="fixed bottom-4 left-4 right-4 md:relative md:bottom-auto md:left-auto md:right-auto">
        <div className="bg-gradient-to-r from-gray-900/80 to-gray-800/70 border border-gray-800 rounded-2xl p-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <button className="p-2 rounded-lg bg-gray-800/40">Explore</button>
            <button className="p-2 rounded-lg bg-gray-800/40">Orders</button>
            <button className="p-2 rounded-lg bg-gray-800/40">Cart</button>
          </div>
          <div className="text-right">
            <div className="text-sm text-gray-300">Free delivery over ₹999</div>
          </div>
        </div>
      </nav>

      {/* Product modal */}
      {selectedProduct && (
        <div className="fixed inset-0 z-50 flex items-end md:items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70" onClick={() => setSelectedProduct(null)} />
          <div className="relative w-full max-w-md bg-gray-900 rounded-xl p-4 z-10">
            <div className="flex items-start justify-between gap-2">
              <div>
                <h3 className="text-lg font-bold">{selectedProduct.title}</h3>
                <p className="text-xs text-gray-400">{selectedProduct.category}</p>
              </div>
              <button onClick={() => setSelectedProduct(null)} className="p-2 rounded-md bg-gray-800/50">
                ✕
              </button>
            </div>
            <p className="mt-3 text-sm text-gray-300">{selectedProduct.desc}</p>
            <div className="mt-4 flex items-center justify-between">
              <div>
                <div className="text-xl font-bold">₹{selectedProduct.price}</div>
                <div className="text-xs text-gray-400">⭐ {selectedProduct.rating}</div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => {
                    toggleFav(selectedProduct.id);
                  }}
                  className={`px-3 py-2 rounded-md ${favorites.includes(selectedProduct.id) ? "bg-pink-600 text-white" : "bg-gray-700/50"}`}
                >
                  {favorites.includes(selectedProduct.id) ? "Saved" : "Save"}
                </button>
                <button
                  onClick={() => {
                    alert("Added to cart (dummy) — implement cart logic in your app.");
                  }}
                  className="px-3 py-2 rounded-md bg-pink-600"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
